var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelFlickr = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 29,
  viewBox: "0 0 64 29",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M14.345 0C22.268 0 28.69 6.491 28.69 14.5c0 8.008-6.422 14.5-14.345 14.5S0 22.508 0 14.5C0 6.49 6.422 0 14.345 0m35.31 0C57.578 0 64 6.492 64 14.5S57.578 29 49.655 29 35.31 22.508 35.31 14.5 41.732 0 49.655 0m0 4.462c-5.485 0-9.93 4.494-9.93 10.038s4.445 10.038 9.93 10.038 9.931-4.494 9.931-10.038-4.446-10.038-9.93-10.038"
})));
export default SvgChannelFlickr;